(function () {
    var s = (typeof (Vendd) != "undefined" && Vendd.Scripts) || (typeof (Scripts) != "undefined" && Scripts);
    if (!s) return;
    s.load(function () {
        'use strict';
        var TrackingScriptName = 'GoogleDynamicRemarketing';

        var TrackingModel = LhApp.Function.Tracking.getTrackingModel();
        var Tracker = LhApp.Function.Tracking.getTracker("googledynamicremarketing", TrackingModel);

        if (!Tracker)
            return;

        var cookieType = Tracker.CookieGroupCode ? Tracker.CookieGroupCode : '';
        var CanTrack = LhApp.Function.Tracking.canTrack(cookieType);

        var _userIdentifier = ''; 
        var _isUserSelectedProduct;
        var _currentPath = new Array();

        Init();        

        function Init() {
            if (!CanTrack) return;

            LhApp.Function.Tracking.InitGoogleTagManager();

            window.dataLayer = window.dataLayer || [];
           
            //TRACK order completion
            if (TrackingModel.IsThankYouPage && TrackingModel.CartProductsData && TrackingModel.Order) {
                if (TrackingModel.Order.IsAlreadyTracked)
                    return;

                if (typeof angular !== 'undefined') {
                    angular.element(document).ready(function () {
                        var oScope = angular.element('.x-control.x-angular-control.x-checkoutorder').scope();
                        var tracked = false;
                        if (oScope && !tracked) {
                            if (TrackingModel.IsThankYouPage) //cookie consent had been granted
                            {
                                tracked = true;

                                if (oScope.Model.Data.Profile.HashedEmail)
                                    _userIdentifier = oScope.Model.Data.Profile.HashedEmail;

                                var ids = [];
                                var items = TrackingModel.CartProductsData;
                                for (var i = 0, len = items.length; i < len; i++) {
                                    var product = items[i];
                                    var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                                    if(ids.indexOf(productId) < 0)
                                        ids.push(productId);
                                };

                                window.dataLayer.push({
                                    'ecomm_prodid': ids,
                                    'ecomm_userid': _userIdentifier,
                                    'ecomm_pagetype': 'purchase',
                                    'ecomm_totalvalue': TrackingModel.Order.TotalPriceN
                                });
                            }
                        }
                    });
                }
            }
        }

        // IMPORTANT execute this scripts in all other pages except checout
        if (typeof (Vendd) != "undefined" && Vendd.Scripts) {

            //On consents update, re-initialize this tracker
            Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertAllCookiesSuccess, TrackingScriptName, function () {
                CanTrack = LhApp.Function.Tracking.canTrack(cookieType);
                Init();
            });

            //in the case of criteo we first have to retrive user email before sending trcking in
            Vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModelSuccess, TrackingScriptName, function (envelope) {
                if (!CanTrack) return;

                if (envelope && envelope.message && envelope.message.data && envelope.message.data.model) {
                    if (envelope.message.data.model.IsAuthenticated && envelope.message.data.model.HashedEmail) {
                        _userIdentifier = envelope.message.data.model.HashedEmail;
                    }

                    if (TrackingModel.IsHomePage) {
                        window.dataLayer.push({
                            'ecomm_userid': _userIdentifier,
                            'ecomm_pagetype': 'home'
                        });
                    } else if (LhApp.Context.Item.Template === 'searchresults' || LhApp.Context.Item.Template === 'search_products') {
                        var ids = [];  
                        for (var list in TrackingModel.ProductListsData) {
                            var listItems = TrackingModel.ProductListsData[list];
                            for (var i = 0; i < listItems.length; i++) {
                                var product = listItems[i];
                                var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                                if (ids.indexOf(productId) < 0)
                                    ids.push(productId);
                            };
                        }

                        window.dataLayer.push({
                            'ecomm_prodid': ids,
                            'ecomm_userid': _userIdentifier,
                            'ecomm_pagetype': 'searchresults'
                        });
                    } else if (TrackingModel.IsProductListPage) {
                        window.dataLayer.push({
                            'ecomm_userid': _userIdentifier,
                            'ecomm_pagetype': 'category',
                            'ecomm_category': TrackingModel.Path
                        });
                    } else if (TrackingModel.IsProductDetailsPage && TrackingModel.ProductData && TrackingModel.ProductData.length > 0) {
                        var product = TrackingModel.ProductData[0];
                        var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                        _currentPath = product.Path.slice(0, product.Path.length - 1);

                        window.dataLayer.push({
                            'ecomm_userid': _userIdentifier,
                            'ecomm_pagetype': 'product',
                            'ecomm_category': _currentPath,
                            'ecomm_prodid': [productId],
                            'ecomm_totalvalue': product.PriceN
                        });
                    } else if (TrackingModel.IsCartPage) {
                        //this is handled in cart change
                    }
                    else {
                        window.dataLayer.push({
                            'ecomm_userid': _userIdentifier,
                            'ecomm_pagetype': 'other'
                        });
                    }
                }
            });

            Vendd.MessageBus.subscribe(Vendd.Product.Messages.SetSelected, TrackingScriptName, function (envelope) {
                //determine if this has been auto raised during product details load in order to avoid tracking twice the product view
                _isUserSelectedProduct = envelope.message.data.visitorInitiated;
            });
            //TRACK product view (changed)
            Vendd.MessageBus.subscribe(Vendd.Product.Messages.Changed, TrackingScriptName, function (envelope) {
                if (!CanTrack) return;

                if (!_isUserSelectedProduct)
                    return;

                var model = envelope.message.data.model;

                var product = model;
                var productId = LhApp.Function.Tracking.getFeedItemId(product, 'ProductChanged', Tracker);

                window.dataLayer.push({
                    'ecomm_userid': _userIdentifier,
                    'ecomm_pagetype': 'product',
                    'ecomm_category': _currentPath,
                    'ecomm_prodid': [productId],
                    'ecomm_totalvalue': product.Prices.UnitPriceN
                });
            });

            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, TrackingScriptName, function (envelope) {
                if (!CanTrack) return;

                if (TrackingModel.IsCartPage) {

                    var items = envelope.message.data.Cart.Items || [];
                    var ids = [];
                    for (var i = 0, len = items.length; i < len; i++) {
                        var product = items[i];
                        var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                        if(ids.indexOf(productId) < 0)
                            ids.push(productId);
                    };

                    window.dataLayer.push({
                        'ecomm_userid': _userIdentifier,
                        'ecomm_pagetype': 'cart',
                        'ecomm_prodid': ids,
                        'ecomm_totalvalue': envelope.message.data.Cart.Summary.TotalPrice
                    });
                }
            });
        }
    });
})();
